import { render } from "./WhatsappOnboardingNav.vue?vue&type=template&id=27c87cb2"
import script from "./WhatsappOnboardingNav.vue?vue&type=script&lang=ts"
export * from "./WhatsappOnboardingNav.vue?vue&type=script&lang=ts"
script.render = render

export default script